/**
 * Shared visit-header fields for dedicated OT notes:
 * billing code + 12-hour Time In / Time Out (AM/PM).
 * Reuses PT time helpers; OT-centric billing options.
 */

import {
  TIME_OPTIONS_15,
  assertPtVisitMetaForFlag,
  buildPtVisitMetaProps,
  emptyPtVisitMeta,
  normalizeTimeOption,
  parseTime12,
  pickPtVisitMeta,
  time12ToMinutes,
} from "../ptNotes/ptVisitCommon";

export const OT_BILLING_CODE_OPTIONS = [
  { value: "G0152", label: "G0152 — Home Health Occupational Therapy" },
  { value: "G0158", label: "G0158 — OT Assistant (OTA)" },
  { value: "97535", label: "97535 — Self-Care / Home Management Training" },
  { value: "97530", label: "97530 — Therapeutic Activities" },
  { value: "97110", label: "97110 — Therapeutic Exercise" },
  { value: "97112", label: "97112 — Neuromuscular Re-education" },
  { value: "97542", label: "97542 — Wheelchair Management" },
];

export {
  TIME_OPTIONS_15,
  emptyPtVisitMeta as emptyOtVisitMeta,
  parseTime12,
  normalizeTimeOption,
  time12ToMinutes,
  pickPtVisitMeta as pickOtVisitMeta,
  assertPtVisitMetaForFlag as assertOtVisitMetaForFlag,
};

/** Visit meta props with OT billing code list. */
export const buildOtVisitMetaProps = (args) => {
  const props = buildPtVisitMetaProps(args);
  return {
    ...props,
    billingOptions: OT_BILLING_CODE_OPTIONS,
  };
};
